window.dataLayer = window.dataLayer || [];

import { clickHandler } from '@/ui/scripts/analytics/analytics.methods';

const eventName = 'eventFilter_tracking';
const actionPropTitle = 'eventFilter_action';
const labelPropTitle = 'eventFilter_label';

const elements = [...document.querySelectorAll('.js-events-filter-form-ga')];

function bindEventListener(el) {
  el.addEventListener('submit', (e) => {
    clickHandler(
      {
        event: eventName,
        actionProp: actionPropTitle,
        labelProp: labelPropTitle,
        action: 'Click',
        label: `${determineSelectedFilters(el).trim()}`,
      },
      e,
    );
  });
}

function determineSelectedFilters(el) {
  const fd = new FormData(el);
  const selectedFilters = Array.from(fd.entries(), (field) => field[1]);
  return selectedFilters.join(', ');
}

function init() {
  if (!elements.length) {
    return;
  }
  elements.forEach(bindEventListener);
}

export default init;
